import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "gmail",
  "name": "Gmail",
  "category": "integrations",
  "description": "Send and receive emails with Gmail",
  "icon": "siGmail",
  "iconType": "simple-icon",
  "color": "red",
  "version": "2.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Gmail",
    "color": "#ea4335"
  },
  "credentials": [
    {
      "name": "googleOAuth2",
      "required": true,
      "displayName": "Google OAuth2"
    }
  ],
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "gmail",
    "email",
    "google",
    "mail",
    "send"
  ],
  "comingSoon": true
};

export default definition;
